import type { ReactNode } from "react"
import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    subheading: {
        marginTop: ".375rem",
        padding: "1rem 0 .125rem",
        borderTop: `1px solid ${theme.palette.tailwind.slate[100]}`,
        color: theme.palette.tailwind.slate[600],
    },
}))

type Props = Readonly<{
    children: ReactNode
}>

export function MeetingRoomDrawerSubheading({ children }: Props) {
    const { classes } = useStyles()

    return (
        <Typography variant="subtitle2" component="div" className={classes.subheading}>
            {children}
        </Typography>
    )
}
